var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Container from '../Container';
var StepperItem = styled(Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  align-self: stretch;\n  transition: all 750ms;\n"], ["\n  width: 100%;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  align-self: stretch;\n  transition: all 750ms;\n"])));
export { StepperItem };
var templateObject_1;
//# sourceMappingURL=styles.js.map